import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../app/Card/Card';
import { Button } from '../../../ui/Button/Button';

export interface BillingPaywallProps {
  /**
   * Open the latest unpaid `Billing.checkout.url` in a new tab. The
   * call is synchronous (no backend round-trip) so there's no
   * `isPaying` state — see `useBillingPayManager`.
   */
  onPayNow?: () => void;
  onResubscribe?: () => void;
}

export function BillingPaywall({ onPayNow, onResubscribe }: BillingPaywallProps) {
  const { t } = useTranslation('m-billing');
  return (
    <Card className="flex flex-col gap-4 p-6">
      <h2 className="text-lg font-semibold">{t('checkout.paywall.title')}</h2>
      <p className="text-sm text-muted-foreground">{t('checkout.paywall.description')}</p>
      <div className="flex flex-wrap gap-2">
        {onPayNow && <Button onClick={onPayNow}>{t('checkout.paywall.pay_now')}</Button>}
        {onResubscribe && (
          <Button variant="outline" onClick={onResubscribe}>
            {t('checkout.paywall.resubscribe')}
          </Button>
        )}
      </div>
    </Card>
  );
}
